import { Box, List, Text, DateInput as GrommetDateInput} from 'grommet';
import { format, parseISO } from 'date-fns';
import React, { useState } from 'react';
import { formatDate } from '../../utils/dates';
import Modal from '../Modal';
import {
    IconCalendar
} from '@tabler/icons-react';
import Icon from '../Icon';
import Button from '../Button';
import { snakeCase } from '../../utils/string';

const DateModal = ({value, onChange, datePresets, containerProps, title, futureDatesOnly=false, placeholder="", wrapperProps}) => {
    const [selectedDate, setSelectedDate] = useState(value); // default is tomorrow
    const [activeMenuItem, setActiveMenuItem] = useState(0);
    const [openModal, setOpenModal] = useState(false);

    return (
        <Box direction='row' {...wrapperProps}>
            <Button
                event={{section: 'date_modal', element: 'open_modal'}}
                fill="horizontal"
                label={(
                    <Box width="small" direction="row" justify="between" pad="10px" {...containerProps} fill="horizontal">
                        <Text {...(value ? {} : {color: 'text-xweak'})}>{value ? formatDate(value) : placeholder}</Text>
                        <Icon SelectedIcon={IconCalendar} size="small" />
                    </Box>
                )}
                plain
                onClick={()=>{setOpenModal(true)}}
            />
            { openModal &&
            (<Modal
                onSubmit={() => {
                    // Structured for Formfield OnChange (needs value key)
                    onChange({value: new Date(selectedDate)});
                }}
                ctaText="Select date"
                onClose={()=>{setOpenModal(!openModal)}}
                title={title}
                footerProps={{pad: "0"}}
                secondaryCtaText="Unset date"
                onSecondaryCtaClicked={() => {
                    onChange({value: null});
                    setOpenModal(false);
                }}
                contentProps={{pad: {vertical: 'small', horizontal: 'xsmall'}}}>
                <Box direction="row" gap="xsmall">
                    <Box border={{side: 'right'}}>
                        <List
                            data={datePresets}
                            pad={{right: 'medium'}}
                            margin={{left: 'xxsmall', top: 'xsmall'}}
                            gap="xsmall"
                        >
                            {(item, index) => (
                                <Box background={activeMenuItem === index ? "brand" : "none"} round="xsmall">
                                    <Button
                                        event={{section: 'date_modal', element: 'select_date', description: snakeCase(item.label)}}
                                        label={(
                                            <Box
                                                round="xsmall"
                                                fill="horizontal">
                                                <Text textAlign="start" weight={activeMenuItem === index ? 600 : 400}>{item.label}</Text>
                                            </Box>
                                        )}
                                        onClick={() => {
                                            setSelectedDate(item.date);
                                            setActiveMenuItem(index);
                                        }}
                                    />
                                </Box>
                            )}
                        </List>
                    </Box>
                    <Box>
                        <GrommetDateInput
                            inline
                            value={selectedDate}
                            onChange={({ value }) => {
                                setSelectedDate(value);

                                // check if user selected any pre-existing menu item
                                const formattedSelectedValue = format(parseISO(value), 'yyyy-MM-dd');
                                const matchingMenuItem = datePresets.findIndex(item => item.date === formattedSelectedValue);
                                setActiveMenuItem(matchingMenuItem > -1 ? matchingMenuItem : undefined);
                            }}
                            calendarProps={{
                                alignSelf: "center",
                                daysOfWeek: true,
                                bounds: [futureDatesOnly ? format(new Date(), 'yyyy-MM-dd') : '2000-01-01', '2525-01-01'],
                                animate: false,
                                showAdjacentDays: "trim"
                            }}
                        />
                    </Box>
                </Box>
            </Modal>)
            }
        </Box>
    );
};

export default DateModal;